import Dream from '../dream';

/**
 * Create the action
 */

const { thunk, request, success, error } = Dream.index((fetch) =>
  fetch.get('/dreams/dream')
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
